'use client'

import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import CasinoIcon from '@mui/icons-material/Casino';
import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import Stack from '@mui/material/Stack';
import { Typography } from '@mui/material';


function numberWithCommas(x: number) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function RatingStars({ rating }: { rating: number }) {
    const starCount = 5;
    const starIcons = new Array(starCount);

    let remainingRating = rating;

    const starSx = { fontSize: { xs: '1rem', md: '1.5rem' }, color: "gold" } as const;

    for (let i = 0; i < starCount; i++) {
        if (remainingRating > 1) {
            starIcons[i] = <StarIcon sx={starSx} key={i} />;
        } else {
            if (remainingRating >= 0.3 && remainingRating <= 0.7) {
                starIcons[i] = <StarHalfIcon sx={starSx} key={i} />;
            } else if (remainingRating > 0.7) {
                starIcons[i] = <StarIcon sx={starSx} key={i} />;
            } else {
                starIcons[i] = <StarBorderIcon sx={starSx} key={i} />;
            }
        }
        remainingRating -= 1;
    }

    return (
        <Stack direction={'row'} spacing={0}>
            {starIcons.map(starIcon => starIcon)}
        </Stack>
    );
}

/**
 * This is a React functional component that renders the casino data in the list of casinos.
 * @returns {JSX.Element}
 */
export default function CasinoRating({ rating, userRatings, forceNumber = false }: { rating: number, userRatings: number, forceNumber?: boolean }) {

    return (
        <Stack spacing={0.5} direction={'row'}>
            <Typography sx={{ marginTop: '1px', display: { xs: 'none', md: 'block' }, alignContent: 'end' }} variant='body1'>{rating}</Typography>
            <RatingStars rating={rating} />
            <Typography sx={forceNumber ? { alignContent: 'end' } : { display: { xs: 'none', md: 'block' }, alignContent: 'end' }} variant='body2'>({numberWithCommas(userRatings)})</Typography>
        </Stack>
    );
}
